import { typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

const getDimension = ($size?: number, $isCondensed?: boolean) =>
  $size ? `${$size}px` : $isCondensed ? '20px' : '48px';

const sharedSizeStyles = css<{
  $isCondensed: boolean;
  $size?: number;
}>`
  height: ${({ $size, $isCondensed }) => getDimension($size, $isCondensed)};
  width: ${({ $size, $isCondensed }) => getDimension($size, $isCondensed)};
`;

export const StyledLogoImg = styled.img<{
  $isCondensed: boolean;
  $size?: number;
}>`
  ${sharedSizeStyles};
  border-radius: 24px;
  background-color: var(--kg-theme);
`;

export const LogoFallback = styled.div<{
  $isCondensed: boolean;
  $size?: number;
}>`
  ${sharedSizeStyles};
  display: flex;
  border-radius: 24px;
  background-color: var(--dark-purple-12);
  color: var(--dark-purple-9);
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  ${({ $isCondensed }) =>
    $isCondensed ? typographyV2.titleXs : typographyV2.titleXL}
`;
